var map = {
	"./Group 1267.svg": "AwQm",
	"./Group 1360.svg": "RdR/",
	"./Group 16.svg": "Itfo",
	"./Group 1941.svg": "J3Di",
	"./Group 3022.svg": "Np+y",
	"./Group 37.svg": "LilQ",
	"./Group 38.svg": "CZPK",
	"./Group 4717.svg": "m+DS",
	"./Group 4719.svg": "UQ8v",
	"./Group 4725.svg": "omWP",
	"./Group 4726-2.svg": "352Y",
	"./Group 4726.svg": "m9XZ",
	"./Group 4727.svg": "NhSj",
	"./Group 4728.svg": "AZQv",
	"./Group 4841.svg": "Hxm1",
	"./Group 73-2.svg": "nEOC",
	"./Group 73.svg": "QSOG",
	"./Path 2492.svg": "5/RP",
	"./Path 2494.svg": "Zk5H",
	"./Path 2623.svg": "G+KB",
	"./Path 429.svg": "CaNN",
	"./Path 434.svg": "IOED",
	"./Path 436.svg": "E+/Q",
	"./Path 617.svg": "fGCe",
	"./Path 707-2.svg": "jWiy",
	"./Path 707.svg": "xzOP",
	"./alipay.svg": "3DrL",
	"./arrow-right.svg": "dxdv",
	"./arrow.svg": "nCIC",
	"./black-envelope.svg": "WNju",
	"./cart-black.svg": "tgOc",
	"./cart.svg": "FkN6",
	"./change.svg": "Ufd9",
	"./close.svg": "toIl",
	"./exit.svg": "QQPv",
	"./eyes-close.svg": "V0x5",
	"./eyes-open.svg": "3z2y",
	"./facebook-active.svg": "vrRG",
	"./facebook-black.svg": "xSzT",
	"./facebook.svg": "L+RT",
	"./font-1.svg": "q39a",
	"./font-2.svg": "LeBg",
	"./google.svg": "YgBy",
	"./library-column.svg": "WcnP",
	"./link.svg": "KgwQ",
	"./login-red.svg": "IIAj",
	"./login.svg": "j/EP",
	"./logo-red.svg": "lkku",
	"./logo.svg": "ZY77",
	"./magazine.svg": "+9RC",
	"./menu.svg": "dH9r",
	"./my.svg": "kBws",
	"./pdf2.svg": "F2R6",
	"./pen.svg": "+Kap",
	"./play.svg": "ufmG",
	"./search-red.svg": "9Arq",
	"./search.svg": "Bx0U",
	"./story-interview.svg": "Ofx6",
	"./tt-active.svg": "ed33",
	"./tt.svg": "Bnbz",
	"./unionpay.svg": "54Hg",
	"./wb-active.svg": "Ke+y",
	"./wb.svg": "jqT5",
	"./wx-active.svg": "1vKt",
	"./wx.svg": "TcIh",
	"./youtube-active.svg": "JGT/",
	"./youtube.svg": "7CXz",
	"./yzm.svg": "1hRL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 3